export default "__VITE_ASSET__BkU5sRGI__"